import React from 'react';
import './SlideOutPanel.css';

/**
 * 슬라이드 아웃 패널 컴포넌트
 * 폼 왼쪽에서 슬라이드되어 나타나는 패널
 */
const SlideOutPanel = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  width = '400px' 
}) => {
  return (
    <div className={`slideout-overlay ${isOpen ? 'open' : ''}`}>
      {/* 배경 클릭 시 닫기 */}
      <div 
        className="slideout-backdrop" 
        onClick={onClose}
      />
      
      {/* 슬라이드 패널 */}
      <div 
        className={`slideout-panel ${isOpen ? 'open' : ''}`}
        style={{ width }}
      >
        <div className="slideout-header">
          <h3 className="slideout-title">{title}</h3>
          <button 
            className="slideout-close-btn"
            onClick={onClose}
            aria-label="패널 닫기"
          >
            ✕
          </button>
        </div>
        
        <div className="slideout-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SlideOutPanel; 